import { render, staticRenderFns } from "./balans.vue?vue&type=template&id=14b73e6d&"
import script from "./balans.vue?vue&type=script&lang=js&"
export * from "./balans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports